export default __webpack_public_path__ + "static/media/undraw_account_490v.ac342c71.svg";